import { Button, Flex, Group, Loader, Progress, Tooltip } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { resetSpaceValidationRunInRedux } from "./designSlice";
import { MdClear } from "react-icons/md";
import React, { useMemo } from "react";

export const ValidationBar: React.FC = () => {
  const spaceValidationRun = useAppSelector((state) => state.design.spaceValidationRun);

  const dispatch = useAppDispatch();
  const nrOfValidRooms = useMemo(() => {
    return spaceValidationRun.spacesValidationsResults.reduce((acc, curr) => {
      if (curr.spaceValidations.every((v) => v.status === "VALID")) {
        return acc + 1;
      }
      return acc;
    }, 0);
  }, [spaceValidationRun.spacesValidationsResults]);

  const nrOfInvalidRooms = useMemo(() => {
    return spaceValidationRun.spacesValidationsResults.length - nrOfValidRooms;
  }, [spaceValidationRun.spacesValidationsResults, nrOfValidRooms]);

  const percentageValidRooms = useMemo(() => {
    return (nrOfValidRooms / spaceValidationRun.spacesValidationsResults.length) * 100;
  }, [nrOfValidRooms, spaceValidationRun.spacesValidationsResults.length]);

  const percentageInvalidRooms = useMemo(() => {
    return (nrOfInvalidRooms / spaceValidationRun.spacesValidationsResults.length) * 100;
  }, [nrOfInvalidRooms, spaceValidationRun.spacesValidationsResults.length]);

  return (
    <Group p={5} w="100%" bg="white">
      <Flex w="100%">
        {spaceValidationRun.loading && <Loader />}
        <Tooltip label="Rens" position="bottom">
          <Button onClick={() => dispatch(resetSpaceValidationRunInRedux())}>
            <MdClear />
          </Button>
        </Tooltip>
        <Progress.Root size="xl" w="100%">
          <Progress.Section value={percentageValidRooms} color="green">
            <Progress.Label>{nrOfValidRooms}</Progress.Label>
          </Progress.Section>
          <Progress.Section value={percentageInvalidRooms} color="red">
            <Progress.Label>{nrOfInvalidRooms}</Progress.Label>
          </Progress.Section>
        </Progress.Root>
      </Flex>
    </Group>
  );
};
